module.exports = __webpack_public_path__ + "img/ma-back.f32617f5.png";